import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const ThemeContext = createContext(null);
const STORAGE_KEY = "prosper360.theme";

function applyTheme(theme) {
    const el = document.documentElement;
    if (theme === "dark") el.classList.add("dark");
    else el.classList.remove("dark");
}

export function ThemeProvider({ children }) {
    const [theme, setThemeState] = useState(() => {
        if (typeof window === "undefined") return "light";
        try {
            const stored = localStorage.getItem(STORAGE_KEY);
            if (stored === "light" || stored === "dark") return stored;
            if (window.matchMedia?.("(prefers-color-scheme: dark)").matches) return "dark";
        } catch (err) {
            // eslint-disable-next-line no-console
            console.warn("[ThemeProvider] failed to read stored theme:", err);
        }
        return "light";
    });

    useEffect(() => {
        applyTheme(theme);
        try {
            localStorage.setItem(STORAGE_KEY, theme);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.warn("[ThemeProvider] failed to persist theme:", err);
        }
    }, [theme]);

    const setTheme = useCallback((t) => setThemeState(t), []);
    const toggle = useCallback(
        () => setThemeState((t) => (t === "dark" ? "light" : "dark")),
        [],
    );

    const value = useMemo(() => ({ theme, setTheme, toggle }), [theme, setTheme, toggle]);
    return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
    const ctx = useContext(ThemeContext);
    if (!ctx) throw new Error("useTheme deve ser usado dentro de ThemeProvider");
    return ctx;
}
